module.exports = __webpack_public_path__ + "img/resources-768.cf48f170.jpg";